// Device capability, quality tiers and small maths helpers for the lab engine

// Simulation size (particles = width × height), pixel-ratio cap and bloom strength per tier
export const QUALITY = {
  high: { grid: [384, 384], dpr: 2, bloom: 1 },
  medium: { grid: [256, 320], dpr: 1.5, bloom: 1 },
  low: { grid: [176, 176], dpr: 1, bloom: 0.8 }
};

export const supportsWebGL2 = () => {
  try {
    return !!document.createElement('canvas').getContext('webgl2');
  } catch {
    return false;
  }
};

// Phones, small screens and modest machines get the light tier; 8+ cores get the full field
export const pickQuality = () => {
  const coarse = window.matchMedia?.('(pointer: coarse)').matches;
  const small = Math.min(window.innerWidth, window.innerHeight) < 700;
  const cores = navigator.hardwareConcurrency || 4;
  if (coarse || small || cores <= 4 || (navigator.deviceMemory || 8) <= 4) return 'low';
  return cores >= 8 && window.devicePixelRatio <= 2 ? 'high' : 'medium';
};

export const loadImage = src =>
  new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });

export const nextFrame = () => new Promise(resolve => setTimeout(resolve, 0));
export const clamp = (x, a, b) => Math.min(b, Math.max(a, x));
export const smoothstep = (a, b, x) => {
  const t = clamp((x - a) / (b - a), 0, 1);
  return t * t * (3 - 2 * t);
};
// Frame-rate independent easing factor toward a target
export const damp = (lambda, dt) => 1 - Math.exp(-lambda * dt);
// 0 → 1 → 0 over t in [0, 1]
export const pulse = t => Math.sin(Math.PI * clamp(t, 0, 1));
export const inOutCubic = t => (t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2);
